import React from 'react';
import Chip from '@mui/material/Chip';

interface StatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

const colorMap: Record<string, string> = {
  in_storage: '#1976D2',
  picked: '#1976D2',
  staged: '#F57C00',
  loaded: '#2E7D32',
  at_intake: '#9E9E9E',
  active: '#CB6015',
  completed: '#2E7D32',
  ready: '#F57C00',
};

const labelMap: Record<string, string> = {
  in_storage: 'In Storage',
  picked: 'Picked',
  staged: 'Staged',
  loaded: 'Loaded',
  at_intake: 'At Intake',
  active: 'Active',
  completed: 'Completed',
  ready: 'Ready',
};

export default function StatusChip({ status, size = 'small' }: StatusChipProps) {
  return (
    <Chip
      label={labelMap[status] || status}
      size={size}
      sx={{
        backgroundColor: colorMap[status] || '#9E9E9E',
        color: '#FFFFFF',
        fontWeight: 500,
      }}
    />
  );
}
